// import React, { useEffect, useRef, useState } from "react";
// import AddButton from "../Buttons/add";
// import { useNavigate } from "react-router-dom";
// import { Breadcrumb, Button, DatePicker, Input, Select } from "antd";
// import {
//   DownloadOutlined,
//   FilterOutlined,
//   SearchOutlined,
//   SwapOutlined,
//   UploadOutlined,
// } from "@ant-design/icons";
// import Container from "../Container";
// import { select_search } from "../../Controllers/Global";
// import toast from "react-hot-toast";
// import dayjs from "dayjs";

// const Header = (props) => {
//   const { headers, setHeaders, formdata } = props;

//   const { RangePicker } = DatePicker;

//   let navigate = useNavigate();

//   const headerRef = useRef();

//   const handleFormData = (e) => {
//     let data = {};
//     headers?.components?.map((value, index) => {
//       data[value.name] = value.value;
//     });

//     // setHeaders(headers);
//     formdata(data);
//   };

//   const handleSearch = (e, i) => {
//     headers.components[i].value = e?.target?.value;
//     setHeaders(headers);
//     handleFormData();
//   };

//   const handleSelect = (e, i) => {
//     headers.components[i].value = e;
//     setHeaders(headers);
//     handleFormData();
//   };

//   const handleDate = (e, i) => {
//     headers.components[i].value = e?.$d;
//     setHeaders(headers);
//     handleFormData();
//   };

//   const handleRange = (e, i) => {
//     headers.components[i].value = {
//       start: e?.[0]?.$d,
//       end: e?.[1]?.$d,
//     };

//     setHeaders(headers);
//     handleFormData();
//   };

//   const handleTabs = (e) => {
//     const data = [];
//     const lastIndex = e?.length - 1;

//     e?.map((value, index) => {
//       data.push({
//         title: value?.name,
//         onClick: () => navigate(value?.path),
//         className:
//           value?.path && index !== lastIndex
//             ? "text-black-200 cursor-pointer hover:text-[#2d53da]"
//             : value?.path && index === lastIndex
//             ? "breadcrumb-tab-color cursor-pointer hover:text-[#2d53da]"
//             : "text-black ",
//       });
//     });

//     return data;
//   };

//   const handleMenu = (e) => {
//     const data = [];

//     e?.map((value, index) => {
//       data?.push({
//         title: value?.name,
//         onClick: () => navigate(value?.path),
//         className: value?.path ? "cursor-pointer hover:text-[#2d53da]" : "",
//       });
//     });

//     return data;
//   };

//   const handleSelectSearch = async (e, index) => {
//     let data = { ...headers };

//     if (data.components[index].api) {
//       const select = {
//         api: data.components[index].api,
//         search: e,
//         status: 1,
//       };

//       const search = await select_search(select);

//       if (search?.status) {
//         let options = [];

//         if (data.components[index].name == "purchase") {
//           search?.data?.data.forEach((value) => {
//             options.push({ value: value._id, label: `#PO-${value.number}` });
//           });
//         } else if (data.components[index].name == "customer") {
//           search?.data?.data?.map((value, index) => {
//             options?.push({
//               value: value?._id,
//               label:
//                 value?.name && value?.phone
//                   ? value?.name + " (" + value?.phone + ")"
//                   : value?.name
//                   ? value?.name
//                   : value?.phone
//                   ? value?.phone
//                   : "",
//             });
//           });
//         } else {
//           search?.data?.data.forEach((value) => {
//             options.push({ value: value._id, label: value.name });
//           });
//         }

//         data.components[index].options = options;

//         setHeaders(data);
//       } else {
//         toast.error(search.message);
//       }
//     }
//   };

//   const handleOnKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//     }
//   };

//   useEffect(() => {
//     headerRef?.current?.focus();
//   }, []);

//   return (
//     <div>
//       <div className="fixed top-16 left-64 right-0 z-20">
//         <div className="p-4 flex justify-between items-center border-b bg-white h-[60px]">
//           <div className="outline-none" ref={headerRef} tabIndex={-1}>
//             {headers?.name}
//           </div>
//           <div>
//             <div className="flex">
//               {headers?.components?.map((value, index) => {
//                 return (
//                   <div
//                     className={
//                       headers?.components?.length == index + 1 ? "" : "pr-2"
//                     }
//                   >
//                     {value?.type == "search" ? (
//                       <>
//                         <Input
//                           allowClear
//                           className="search"
//                           placeholder=" Search"
//                           prefix={
//                             <span className="text-gray-500 text-medium">
//                               <SearchOutlined />
//                             </span>
//                           }
//                           // value={value?.value}
//                           onChange={(e) => handleSearch(e, index)}
//                           onKeyDown={handleOnKeyDown}
//                         />
//                       </>
//                     ) : value?.type == "select" || value?.type == "filter" ? (
//                       <Select
//                         allowClear={value?.allowClear}
//                         showSearch={value?.showSearch}
//                         filterOption={value?.filterOption}
//                         className="w-32"
//                         placeholder={
//                           <span>
//                             {value?.type === "select" ? (
//                               <SwapOutlined
//                                 style={{ transform: "rotate(90deg)" }}
//                               />
//                             ) : value?.type === "filter" ? (
//                               <FilterOutlined />
//                             ) : (
//                               ""
//                             )}
//                             <span className="pl-2">{value?.placeholder}</span>
//                           </span>
//                         }
//                         options={value?.options}
//                         onClick={() => handleSelectSearch("", index)}
//                         onSearch={(e) => handleSelectSearch(e, index)}
//                         onChange={(e) => handleSelect(e, index)}
//                         onKeyDown={handleOnKeyDown}
//                         autoComplete="off"
//                       />
//                     ) : value?.type == "upload" ? (
//                       <Button className="text-[#BFBFBF]">
//                         <div className="flex">
//                           <div className="">Export</div>
//                           <div className="pl-4 pt-0.5">
//                             <UploadOutlined />
//                           </div>
//                         </div>
//                       </Button>
//                     ) : value?.type == "date" ? (
//                       <DatePicker
//                         value={value?.value && dayjs(value?.value)}
//                         onChange={(e) => handleDate(e, index)}
//                       />
//                     ) : value?.type == "range" ? (
//                       <RangePicker onChange={(e) => handleRange(e, index)} />
//                     ) : value?.type == "download" ? (
//                       <Button className="text-[#BFBFBF]">
//                         <div className="flex">
//                           <div className="">Import</div>
//                           <div className="pl-4 pt-0.5">
//                             <DownloadOutlined />
//                           </div>
//                         </div>
//                       </Button>
//                     ) : value?.type == "add" ? (
//                       <AddButton onClick={() => navigate(value?.path)} />
//                     ) : (
//                       ""
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//         <div className="p-4 bg-white border-b h-[40px] flex justify-between items-center text-xs text-medium text-gray-400 uppercase">
//           <div>
//             <Breadcrumb
//               className="text-regular"
//               separator=">"
//               items={handleMenu(headers?.navigate?.path)}
//             />
//             <Breadcrumb
//               className="text-regular"
//               separator=">"
//               items={handleTabs(headers?.navigate?.tabs)}
//               lastItemColor="yellow"
//             />
//           </div>
//           <div className="flex">
//             {headers?.navigate?.total?.map((value, index) => {
//               return (
//                 <div
//                   className={
//                     index == headers?.navigate?.total?.length - 1
//                       ? "cursor-pointer my-auto"
//                       : "pr-3 cursor-pointer my-auto"
//                   }
//                 >
//                   {value?.label} ({value?.value})
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//       <Container>{props?.children}</Container>
//     </div>
//   );
// };

// export default Header;

import React, { useEffect, useRef, useState } from "react";
import AddButton from "../Buttons/add";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, Button, DatePicker, Input, Select } from "antd";
import {
  DownloadOutlined,
  FilterOutlined,
  SearchOutlined,
  SwapOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import Container from "../Container";
import { select_search } from "../../Controllers/Global";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { debounce } from "lodash";
import Headercomponent from "../Formcomponents/header";

const Header = (props) => {
  const { headers, setHeaders, formdata } = props;
  const { RangePicker } = DatePicker;
  let navigate = useNavigate();
  const headerRef = useRef();
  const lastScannedBarcode = useRef("");


  const handleSearch = debounce((e, i) => {
    const inputValue = e?.target?.value;

    if (inputValue === lastScannedBarcode.current) return;

    headers.components[i].value = inputValue;
    setHeaders({ ...headers });
    handleFormData();

    lastScannedBarcode.current = inputValue;
  }, 500);

  const handleFormData = () => {
    let data = {};
    headers?.components?.forEach((value) => {
      data[value.name] = value.value;
    });

    formdata(data);
  };

  const handleSelect = (e, i) => {
    headers.components[i].value = e;
    setHeaders({ ...headers });
    handleFormData();
  };

  const handleDate = (e, i) => {
    let date = "";

    if (e?.$d) {
      let localDate = new Date(e?.$d ? e?.$d : new Date());
      localDate.setMinutes(
        localDate.getMinutes() - localDate.getTimezoneOffset()
      );

      date = localDate.toISOString();
    }

    // headers.components[i].value = e?.$d;
    headers.components[i].value = date;
    setHeaders({ ...headers });
    handleFormData();
  };

  const handleRange = (e, i) => {
    let start_date = "";
    let end_date = "";

    if (e?.[0]?.$d && e?.[1]?.$d) {
      //start
      let localDateStart = new Date(e?.[0]?.$d ? e?.[0]?.$d : new Date());
      localDateStart.setMinutes(
        localDateStart.getMinutes() - localDateStart.getTimezoneOffset()
      );

      //end
      let localDateEnd = new Date(e?.[1]?.$d ? e?.[1]?.$d : new Date());
      localDateEnd.setMinutes(
        localDateEnd.getMinutes() - localDateEnd.getTimezoneOffset()
      );

      //ISO Date
      start_date = localDateStart?.toISOString();
      end_date = localDateEnd?.toISOString();
    }

    headers.components[i].value = {
      start: start_date,
      end: end_date,
    };
    setHeaders({ ...headers });
    handleFormData();
  };

  const handleTabs = (e) => {
    return e?.map((value, index) => ({
      title: value?.name,
      onClick: () => navigate(value?.path),
      className:
        value?.path && index !== e?.length - 1
          ? "text-black-200 cursor-pointer hover:text-[#2d53da]"
          : value?.path && index === e?.length - 1
          ? "breadcrumb-tab-color cursor-pointer hover:text-[#2d53da]"
          : "text-black",
    }));
  };

  const handleMenu = (e) => {
    return e?.map((value) => ({
      title: value?.name,
      onClick: () => navigate(value?.path),
      className: value?.path ? "cursor-pointer hover:text-[#2d53da]" : "",
    }));
  };

  const handleSelectSearch = async (e, index) => {
    let data = { ...headers };
    let select;

    if (data.components[index].api) {
      if (data.components[index].source) {
        select = {
          api: data.components[index].api,
          source: data.components[index].source,
          search: e,
          status: 1,
        };
      } else {
        select = {
          api: data.components[index].api,
          search: e,
          status: 1,
        };
      }

      const search = await select_search(select);

      if (search?.status || search?.success) {
        let options = [];

        if (data.components[index].name === "purchase") {
          options = search?.data?.data.map((value) => ({
            value: value._id,
            label: `#PO-${value.number}`,
          }));
        } else if (data.components[index].name === "received") {
          options = search?.data?.data.map((value) => ({
            value: value._id,
            label: `#${value.number}`,
          }));
        } else if (data.components[index].name === "customer") {
          options = search?.data?.data.map((value) => ({
            value: value?._id,
            label:
              value?.name && value?.phone
                ? `${value?.name} (${value?.phone})`
                : value?.name || value?.phone || "",
          }));
        } else if (data.components[index].name === "branch") {
          options = search?.data?.data.map((value) => ({
            value: value?._id,
            label:
              value?.name && value?.phone
                ? `${value?.name} (${value?.phone})`
                : value?.name || value?.phone || "",
          }));
          options?.push({ value: "ALL", label: "ALL" });
        } else {
          options = search?.data?.data.map((value) => ({
            value: value._id,
            label: value.name,
          }));
        }

        data.components[index].options = options;
        setHeaders(data);
      } else {
        toast.error(search.message);
      }
    }
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

  useEffect(() => {
    headerRef?.current?.focus();
  }, []);

  return (
    <div>
      <div>
        <div className="p-4 flex justify-between items-center border-b bg-white h-[60px]">
          <div className="outline-none" ref={headerRef} tabIndex={-1}>
            {headers?.name}
          </div>
          <div className="flex">
            {headers?.components?.map((value, index) => (
              <div
                key={index}
                className={
                  index + 1 === headers?.components?.length ? "" : "pr-2"
                }
              >
                {value?.type === "search" ? (
                  <Input
                    allowClear
                    className="search"
                    placeholder=" Search"
                    prefix={
                      <SearchOutlined className="text-gray-500 text-medium" />
                    }
                    onChange={(e) => handleSearch(e, index)}
                    onKeyDown={handleOnKeyDown}
                  />
                ) : value?.type === "select" || value?.type === "filter" ? (
                  <Select
                    allowClear={value?.allowClear}
                    showSearch={value?.showSearch}
                    filterOption={value?.filterOption}
                    className={value?.className ? value?.className : "w-32"}
                    placeholder={
                      <span>
                        {value?.type === "select" ? (
                          <SwapOutlined
                            style={{ transform: "rotate(90deg)" }}
                          />
                        ) : (
                          <FilterOutlined />
                        )}
                        <span className="pl-2">{value?.placeholder}</span>
                      </span>
                    }
                    options={value?.options}
                    onClick={() => handleSelectSearch("", index)}
                    onSearch={(e) => handleSelectSearch(e, index)}
                    onChange={(e) => handleSelect(e, index)}
                    onKeyDown={handleOnKeyDown}
                    autoComplete="off"
                  />
                ) : value?.type === "date" ? (
                  <DatePicker
                    format={dateFormatList}
                    value={value?.value && dayjs(value?.value)}
                    onChange={(e) => handleDate(e, index)}
                  />
                ) : value?.type === "range" ? (
                  <RangePicker
                    format={dateFormatList}
                    placeholder={value?.placeholder}
                    onChange={(e) => handleRange(e, index)}
                  />
                ) : value?.type === "upload" ? (
                  <Button className="text-[#BFBFBF]">
                    Export <UploadOutlined className="pl-4 pt-0.5" />
                  </Button>
                ) : value?.type === "download" ? (
                  <Button className="text-[#BFBFBF]">
                    Import <DownloadOutlined className="pl-4 pt-0.5" />
                  </Button>
                ) : value?.type === "add" ? (
                  <AddButton onClick={() => navigate(value?.path)} text={value?.text}/>
                ) : null}
              </div>
            ))}
          </div>
        </div>
        <div className="p-4 bg-white border-b h-[40px] flex  items-center text-xs text-medium text-gray-400 uppercase">
          <Breadcrumb
            className="text-regular"
            separator=">"
            items={handleMenu(headers?.navigate?.path)}
          />
          <Breadcrumb
            className="text-regular"
            separator=">"
            items={handleTabs(headers?.navigate?.tabs)}
          />
        </div>
      </div>
      <Container>{props?.children}</Container>
    </div>
  );
};

export default Header;
